<style>
    .ly-app {
        /*display: flex;
        flex: 1;*/
        height: 100%;
    }
    .ly-container-header {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 50px;
        z-index: 99;
    }
    .container {
        position: relative;
    }
    .ly-container {
        position: relative;
        /*display: flex;
        flex: 1;*/
        height: 100%;
    }
    .ly-app-navigation {
        width: 130px;
        height: 100%;
    }
    .ly-container-routerView {
        position: absolute;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 130px;
        overflow: auto;
    }
</style>
<template>
    <div  class="ly-app" v-loading.fullscreen.lock="fullLoading">
        
        <!-- header start -->
        <ly-header class="ly-container-header"></ly-header>
        <!-- header end -->
        <div class="ly-container">
            <!-- 左侧导航 start -->
            <ly-navigation 
                class="ly-app-navigation" 
                :nav="globalRouterConfig"
                @itemclick="handleNavItemClick">        
            </ly-navigation>
            <!-- 左侧导航 start -->
            <!-- router start -->
            <div class="ly-container-routerView" v-if="!fullLoading">
                <!-- <keep-alive include="LyBillList"> -->
                    <router-view class="wtable"></router-view>
                <!-- </keep-alive> -->
            </div>
            <!-- router end -->
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import LyNavigation from '@c/navigation'
    import LyHeader from '@c/header'

    export default {
        name: 'app',
        components: {
            LyNavigation, 
            LyHeader
        },
        data () {
            return {
                defRoutePath: '', // 默认的路由路径
                fullLoading: true // 全屏加载
            }
        },
        computed: {
            ...mapGetters([
                'tokon', 
                'tokonKey',
                'localConfigKey',

                'authorizd',
                'userInfo'     
            ]),
            ...mapGetters('route', [
                'globalRouterConfig'
            ])
        },

        watch: {
            '$route' (to, from) {
                // 跳转到默认路径
                if (to.fullPath === '/') {
                    this.$router.push(this.defRoutePath)// 跳转到默认路由
                }
            }
        },
        created () {
            // 获得当前登录用户的信息
            this.initAccount()
        },
        methods: {
            ...mapActions([
                'updateAuthorizd',
                'initUserInfo'
            ]),
            ...mapActions('route', [
                'initGlobalRouterConfig',
                'updateCurrRoute'
            ]),
            /**
             * 初始化账户信息
             * @return {[type]} [description]
             */
            initAccount () {
                this.$api.account.query({tokon: this.tokon}).then((rs) => {
                    // 用户ID存入本地cookie
                    this.$utils.setCookie('USER_ID', rs.id)
                    // 1、将账号信息保存到vuex中
                    this.initUserInfo(rs)
                    // 2、根据当前用户的版本号获取本地缓存的配置
                    this.getLocalConfig()
                    // 设置当前的title
                    document.title = rs.duty + '|' + rs.company_name
                }).catch((error) => {
                    console.error(error)
                    // this.$notify.error({
                    //     title: '初始化账户错误',
                    //     message: error,
                    //     duration: 0
                    // })
                    this.$utils.loginOut(this.tokon)
                })
            },
            /**
             * 初始化页面配置
             */
            initConfig () {
                this.$api.config.query({tokon: this.tokon}).then((rs) => {
                    // 本地存储配置
                    this.saveLocalConfig(rs)
                     // 初始化完成后的处理
                    this.initComplete(rs.config)
                }).catch((error) => {
                    console.error(error)
                    // this.$notify.error({
                    //     title: '初始化页面配置错误',
                    //     message: error,
                    //     duration: 0
                    // })
                    this.$utils.loginOut(this.tokon)
                })
            }, 
            /**
             * 获取本地缓存的配置
             */
            getLocalConfig () {
                let config = localStorage.getItem(this.localConfigKey)
                config = config ? JSON.parse(config) : config
                // 用户tokon相同，版本号相同，才使用本地数据
                if (config && config.version === this.userInfo.version && config.v3_token === this.tokon) {
                    // 初始化完成后的处理
                    this.initComplete(config.config)
                } else { // 若没有配置，进行获取
                    this.initConfig()
                }
            },
            /**
             * 初始化完成后的处理
             * @param  {[Object]} routeConfig [路由的配置]
             */
            initComplete (routeConfig) {
                 // 初始化全局路由配置
                this.initGlobalRouterConfig(routeConfig)
                // 设置默认路由
                this.initRouteDefault(routeConfig)
                // 获得当前路由对象
                let currRoute = this.$utils.readRouteConfig(this.$route.fullPath)
                // 这里如果没有特定指向一个路由的话，或者当前路由为空，跳转到默认路有去
                if (!this.$route.fullPath || this.$route.fullPath === '/' || !currRoute) {
                    // 设置当前路由为默认路有
                    currRoute = this.$utils.readRouteConfig(this.defRoutePath)
                    // 跳转到默认路由
                    this.$router.push(this.defRoutePath)
                }
                // 更新当前路由
                this.updateCurrRoute(currRoute)
                // 取消全局加载
                this.fullLoading = false
            },
            /**
             * 初始化一个路由的默认配置
             * @create 2018-01-22
             * 这里应该用动态路由配置，现为实现功能，直接设在配置的第一个为默认路由
             * @return {[type]} [description]
             */
            initRouteDefault (route) {
                if (route && route.length > 0) {
                    // 取得一个默认路有对象
                    let r = route[0]
                    let def = r.children ? r.children[0] : r
                    this.defRoutePath = '/' + def.type + '/' + def.path
                    if (def.page && def.page.length > 0) {
                        this.defRoutePath += '/' + def.page[0]['label'] 
                    }
                } else {
                    // this.$message({
                    //     message: '你可能没有权限，请联系管理员',
                    //     type: 'warning'
                    // })

                    this.$alert('你可能没有权限，请联系管理员', '访问受限', {
                        confirmButtonText: '确定',
                          callback: action => {
                          }
                    });
                    this.$utils.loginOut(this.tokon)
                }
                // console.log('this.router::%O', this.$router)
                // this.$router.addRoutes({
                //     path: '',
                //     redirect: to => {
                //         return '/bill'
                //     }
                // })
                // this.$router.addRoutes({
                //     path: 'bill',
                //     redirect: to => {
                //         return '/bill/checkin/list'
                //     }
                // })
            },
            /**
             * 本地存储
             * @param  {[Object]} val [需要保存的内容]
             */
            saveLocalConfig (val) {
                val['tokon'] = this.tokon // 存储当前用户的tokon
                localStorage.setItem(this.localConfigKey, JSON.stringify(val))
            },
            /**
             * 导航的点击监听
             * @param  {[Object]} item [路由信息对象]
             */
            handleNavItemClick (item) {
                if (item.type === 'redirect') { // 重定向类型
                    let url = 'http://' + location.host + '/' + item.path
                    window.open(url)
                } else {
                    let url = '/' + item.type + '/' + item.path
                    if (item.page && item.page.length > 0) {
                        url += '/' + item.page[0]['label']
                    }
                    // 路由的跳转
                    this.$router.push(url)
                    // 更新当前路由
                    this.updateCurrRoute(item)
                }
            }
        }
    }
</script>